import React, { useEffect, useRef, useState } from "react";
import DropdownWrapper from "./DropdownWrapper";
import DropdownButton from "./DropdownButton";

const multiSelectGoldenDropdown = (WrappedComponent) => {
  return function EnhancedComponent({
    heading,
    selectedMember,
    ReportMenuContent,
    reportsMenuOpen,
    setReportsMenuOpen,
    showArrow,
    showPopup,
    isDisabled,
    disabledPopup,
    popUpId = "",
    popUpRole = "",
    ariaHasPopUp = "",
    ariaControls = "",
    setHeadingValue,
    OPTIONS,
    buttonProps,
    popupClassName = {
      open: "",
      close: "",
      wrapperClass: "",
      dropDownContainerClass,
      popupMenuClass,
    },
    btnClass = "",
    accessibilityValues,
    onCustomClose = () => {},
    ...rest
  }) {
    const [isOpen, setIsOpen] = useState(false);

    const [activeIndex, setActiveIndex] = useState(0);

    const buttonRef = useRef(null);
    const listboxRef = useRef(null);
    const wrapperRef = useRef(null);

    const selectedTextRef = useRef(null);

    const [isTextOverflowing, setIsTextOverflowing] = useState(false);

    useEffect(() => {
      if (selectedTextRef?.current) {
        setIsTextOverflowing(
          selectedTextRef?.current?.scrollWidth >
            selectedTextRef?.current?.clientWidth
            ? true
            : false,
        );
      }
    }, [heading, selectedTextRef?.curren]);

    const openDropdown = (index = 0) => {
      setActiveIndex(index);
      setIsOpen(true);
    };

    const closeDropdown = (focusButton = false) => {
      setIsOpen(false);

      if (focusButton) {
        buttonRef.current?.focus();
      }
    };

    useEffect(() => {
      if (isOpen) {
        listboxRef.current?.focus();
      }
    }, [isOpen]);

    useEffect(() => {
      const handleOutsideClick = (event) => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
          closeDropdown(false);
        }
      };

      document.addEventListener("mousedown", handleOutsideClick);

      return () => {
        document.removeEventListener("mousedown", handleOutsideClick);
      };
    }, []);

    const handleButtonKeyDown = (e) => {
      switch (e.key) {
        case "Enter":
        case " ":
          e.preventDefault();
          openDropdown(0);
          break;

        case "ArrowDown":
          e.preventDefault();
          openDropdown(0);
          break;

        case "ArrowUp":
          e.preventDefault();
          openDropdown(OPTIONS.length - 1);
          break;

        default:
          break;
      }
    };

    const handleListboxKeyDown = (e) => {
      switch (e.key) {
        case "ArrowDown":
          e.preventDefault();

          setActiveIndex((prev) =>
            prev === OPTIONS.length - 1 ? 0 : prev + 1,
          );
          break;

        case "ArrowUp":
          e.preventDefault();

          setActiveIndex((prev) =>
            prev === 0 ? OPTIONS.length - 1 : prev - 1,
          );
          break;

        case "Home":
          e.preventDefault();
          setActiveIndex(0);
          break;

        case "End":
          e.preventDefault();
          setActiveIndex(OPTIONS.length - 1);
          break;

        case " ":
        case "Enter":
          e.preventDefault();
          setHeadingValue(OPTIONS[activeIndex].id);
          break;

        case "Escape":
          e.preventDefault();
          closeDropdown(true);
          break;

        case "Tab":
          setIsOpen(false);
          return;

        default:
          break;
      }
    };

    return (
      <>
        <DropdownWrapper
          isDisabled={isDisabled}
          popupClassName={popupClassName}
          heading={heading}
          showPopup={showPopup}
          isTextOverflowing={isTextOverflowing}
          ref={selectedTextRef}
        >
          <>
            <div style={{ position: "relative" }}>
              <div ref={wrapperRef} className={popupClassName.wrapperClass}>
                <button
                  ref={buttonRef}
                  type="button"
                  aria-haspopup={accessibilityValues.ariaHaspopup}
                  aria-expanded={isOpen}
                  aria-controls={accessibilityValues.ariaControls}
                  //  aria-label={`All Asset Classes, ${checkedItems.length} filters selected`}
                  onClick={() =>
                    isOpen ? closeDropdown(false) : openDropdown(0)
                  }
                  onKeyDown={handleButtonKeyDown}
                  className={`children buttonWrapper ${btnClass}`}
                >
                  <DropdownButton
                    heading={heading}
                    dropDownContainerClass={
                      popupClassName.dropDownContainerClass
                    }
                    isTextOverflowing={isTextOverflowing}
                    disabledPopup={disabledPopup}
                    reportsMenuOpen={isOpen}
                    ref={selectedTextRef}
                  />
                </button>

                {isOpen && (
                  <WrappedComponent
                    {...rest}
                    popupClassName={popupClassName}
                    OPTIONS={OPTIONS}
                    setHeadingValue={(data) => setHeadingValue(data)}
                    isOpen={isOpen}
                    handleListboxKeyDown={(e) => handleListboxKeyDown(e)}
                    selectOption={(index) => {
                      selectOption(index);
                    }}
                    accessibilityValues={accessibilityValues}
                    activeIndex={activeIndex}
                    ref={listboxRef}
                  />
                )}
              </div>
            </div>
          </>
        </DropdownWrapper>
      </>
    );
  };
};
export default multiSelectGoldenDropdown;
